import React from 'react'
import './Form.css'

export interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {
  children: React.ReactNode
  className?: string
}

export interface FormGroupProps {
  children: React.ReactNode
  className?: string
  error?: string
}

export interface FormLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  children: React.ReactNode
  required?: boolean
  className?: string
}

export interface FormErrorProps {
  children: React.ReactNode
  className?: string
}

export interface FormHelperTextProps {
  children: React.ReactNode
  className?: string
}

export const Form: React.FC<FormProps> = ({ children, className = '', ...props }) => (
  <form className={`form ${className}`} {...props}>
    {children}
  </form>
)

export const FormGroup: React.FC<FormGroupProps> = ({ children, className = '', error }) => (
  <div className={`form-group ${error ? 'form-group--error' : ''} ${className}`}>
    {children}
    {error && <FormError>{error}</FormError>}
  </div>
)

export const FormLabel: React.FC<FormLabelProps> = ({ children, required = false, className = '', ...props }) => (
  <label className={`form-label ${required ? 'form-label--required' : ''} ${className}`} {...props}>
    {children}
    {required && <span className="form-label-required" aria-label="required">*</span>}
  </label>
)

export const FormError: React.FC<FormErrorProps> = ({ children, className = '' }) => (
  <div className={`form-error ${className}`} role="alert">
    {children}
  </div>
)

export const FormHelperText: React.FC<FormHelperTextProps> = ({ children, className = '' }) => (
  <div className={`form-helper ${className}`}>
    {children}
  </div>
)
